// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import PantallaRegistroPacienteOnline from "./components/crearPaciente/PantallaRegistroPacienteOnline";
import Bienvenida from "./components/welcomePage/WelcomePage";
import Dashboard from "./components/dashboard/Dashboard";
import Login from "./components/login/Login";
import Checkout from "./components/pagos/Checkout";
import BlogPreviewPage from "./components/blog/BlogPreviewPage";
import NotFoundPage from "./components/NotFoundPage"; // Importar NotFoundPage
import NutriologoProfile from "./components/profile/NutriologoProfile";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = React.useContext(AuthContext);
  return isAuthenticated ? children : <Navigate to="/perfil" replace />;
};

const HomeRoute = () => {
  const { isAuthenticated } = React.useContext(AuthContext);
  const destination = isAuthenticated ? "/miperfil" : "/perfil";
  return <Navigate to={destination} replace />;
};

const UnknownRouteRedirect = () => {
  const { isAuthenticated } = React.useContext(AuthContext);
  const destination = isAuthenticated ? "/miperfil" : "/perfil";
  return <Navigate to={destination} replace />;
};

function App(props) {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Ruta raíz que redirige según autenticación */}
          <Route path="/" element={<HomeRoute />} />

          {/* Rutas públicas */}
          <Route
            path="/registro"
            element={<PantallaRegistroPacienteOnline />}
          />
          <Route path="/welcomePage" element={<Bienvenida />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/blog" element={<BlogPreviewPage />} />
          <Route path="/perfil" element={<NutriologoProfile />} />
          <Route path="/login" element={<Login />} />

          {/* Ruta protegida */}
          <Route
            path="/miperfil"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* 404 */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<UnknownRouteRedirect />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
